export const toObject = (source, selector) => {
    const map = {};
    for (const value of source) {
        map[selector(value)] = value;
    }
    return map;
};
